import { POS_ROUTE } from "../../constants/constants";


export const WAIT_LIST_ROUTE = POS_ROUTE + "/waitlist"
